<template>
  <div>
    <div>
      {{ $t(`modals.${config.action}.description`) }}
    </div>
    <div class="link-container body2 mt-3">
      {{ config.item.inviteLink }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module.ts";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig<{ inviteLink: string }>>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.link-container {
  border: 1px rgb(var(--v-theme-indigo-faint)) solid;
  border-radius: 6px;
  padding: 12px 20px 12px 16px;
}
</style>
